import React from 'react'
import { usd, num, compact } from './aiCostFormat'

const Card = ({ label, value, hint }) => (
  <div className="ai-cost-tile">
    <div className="ai-cost-tile-label">{label}</div>
    <div className="ai-cost-tile-value">{value}</div>
    {hint && <div className="ai-cost-tile-hint">{hint}</div>}
  </div>
)

const AISummaryCards = ({ summary, isLoading }) => {
  const s = summary || {}
  const v = (value) => (isLoading && !summary ? '...' : value)

  return (
    <div className="ai-cost-tiles">
      <Card
        label="AI Cost"
        value={v(usd(s.totalCost))}
        hint={s.deepgramBilledCost != null ? `Billed by Deepgram: ${usd(s.deepgramBilledCost)}` : 'Deepgram actual + Gemini estimated'}
      />
      <Card label="Total Requests" value={v(num(s.totalRequests))} />
      <Card label="Audio Minutes" value={v(num(s.audioMinutes, 1))} />
      <Card
        label="Gemini Tokens"
        value={v(compact(s.totalTokens))}
        hint={s.totalTokens ? `In ${compact(s.inputTokens)} · Out ${compact(s.outputTokens)} · Thinking ${compact(s.thinkingTokens)}` : null}
      />
      <Card label="Average Cost / Request" value={v(usd(s.averageCostPerRequest))} />
    </div>
  )
}

export default AISummaryCards
